import { render } from "./Speciessearch.vue?vue&type=template&id=aeb3070e"
import script from "./Speciessearch.vue?vue&type=script&lang=js"
export * from "./Speciessearch.vue?vue&type=script&lang=js"

import "./Speciessearch.vue?vue&type=style&index=0&id=aeb3070e&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-mollusken_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__